<div *ngIf="isOpen"
  class="fixed inset-0 bg-black/50 backdrop-blur-[2px] flex items-center justify-center z-[9999] p-4"
  (click)="onBackdropClick()">
  <div
    class="error-toast-pop relative bg-white rounded-3xl max-w-md w-full shadow-2xl overflow-hidden"
    (click)="$event.stopPropagation()">

    <!-- Top accent bar -->
    <div class="h-1.5 w-full bg-gradient-to-r from-[#f04438] to-[#ff6b6b]"></div>

    <!-- Close -->
    <button (click)="onClose()" aria-label="Close"
      class="absolute right-4 top-5 text-gray-400 hover:text-gray-600 transition-colors">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
      </svg>
    </button>

    <div class="px-7 pt-8 pb-7">

      <!-- Icon -->
      <div class="flex justify-center mb-5">
        <div class="w-16 h-16 rounded-full bg-[#FEF3F2] flex items-center justify-center">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="#F04438" stroke-width="2" />
            <line x1="12" y1="8" x2="12" y2="13" stroke="#F04438" stroke-width="2" stroke-linecap="round" />
            <line x1="12" y1="16.5" x2="12.01" y2="16.5" stroke="#F04438" stroke-width="2" stroke-linecap="round" />
          </svg>
        </div>
      </div>

      <!-- Title -->
      <h3 class="text-center text-xl font-bold text-gray-900 mb-2">{{ title }}</h3>

      <!-- Message -->
      <p class="text-center text-sm text-gray-500 leading-relaxed mb-7">
        {{ message }}
      </p>

      <!-- Button -->
      <button (click)="onClose()"
        class="w-full py-3 rounded-xl bg-[#D31148] text-white font-semibold text-sm
               hover:bg-[#b80e3d] active:scale-[0.98] transition-all">
        OK
      </button>

    </div>

    <!-- Auto-dismiss progress bar -->
    <div *ngIf="autoCloseMs > 0" class="h-1 w-full bg-[#FEF3F2]">
      <div class="h-full bg-[#F04438] error-toast-progress" [style.animation-duration.ms]="autoCloseMs"></div>
    </div>
  </div>
</div>
